import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import styles from './TableList.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { TableActionType as ta } from '@/util/enum';
import { DefaultListFeilds as df } from '../../types';
import { tooltipStyle, tooltip, cellWidth } from '@/components/TableCell';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '模板编号',
            dataIndex: df.id,
            key: df.id,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '模板名称',
            dataIndex: df.name,
            key: df.name,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '备注',
            dataIndex: df.remark,
            key: df.remark,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '条件',
            dataIndex: df.condition,
            key: df.condition,
            width: 500,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '更新时间',
            dataIndex: df.updateTime,
            key: df.updateTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            width: cellWidth.time,
            render: (text, item) => this._renderActionCell(item[df.id], item)
        }
    ]);

    _renderActionCell = (key, item) => {
        const { tableAction } = this.props;

        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(key, ta.detail)}>详情</div>
                <div className={styles.item} onClick={() => tableAction(key, ta.link, item)}>下载模版</div>
            </div>
        );
    }


    render() {
        const { paginationChange, rowSelection } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;

        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={df.id}
                    columns={this._takeColumns()}
                    rowSelection={rowSelection}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;